module.exports = __webpack_public_path__ + "static/media/farmdokMockAppleMobileApplicationEN.d04dd73a.webp";